module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABRUlEQVQ4jd3UMUicQRAF4O/+O0/OImrKFQQJdoGIxJA6GMHKxsbCTn9IwCJ4jXAWhhQ2VsEm0aS0tIyCoqCVNhaKWgXEJgRSBEUsNClujcflDsVY5cE0+9682dnZ3UyapmqgFy8whfO49gAz2MLHK2EIASTIYhLNkevGa2xiHR1oxSo28AT91ZUTXGAR03gXd/AYO3iFJSxjAgt4ikN0VRvBbkz6jFFs4wvyaIytrGAWRyihrdIok6ZpH4ox6Qp5PIqFviMgE2MfZxXaM5RySDGIn9V9R8ziPQ7q8M8xlKDgejJ3wQ80JTfKbokEJ3j4Dx55nOTwFvN4idMawgKGcVmHW8NIgj0MKI+3pUbM4Vkd7hPGQgjH93pG/7nR5R1Ns8qP/k/yBRqUv4jbohM9+Aq5CqKIcbRXJRTwwd/36BvehBB+wW+YxT1mE1SGcAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./app/content/images/icon-gift.png
// module id = MYyb
// module chunks = 11